export default function getSessionTypeLabel(session) {
  if (!session) return null;
  if (session.isBasic) return 'Low Intensity';
  if (session.challengeOrder != null) return `Challenge ${session.challengeOrder}`;
  return null;
}
